import store from '@/store';
import { endpoints } from '@/api/endpoints';
import { handleCustomError } from '@/config/errorHandling';
import { RedirectionType, redirectTo } from '@/helpers/url';
import { mapInitialCartValues } from '@/api/Cart/cart.helpers';

export async function loadCart() {
    try {
        // startPerformanceCart();
        store.dispatch('cart/setCartLoading');
        const response = await endpoints.cart.GetCart('');

        if (response) {
            if (response.ErrorMessage) {
                const { ErrorMessage, RedirectUrlOnExpiration } = response;
                const redirectFlightFailed =
                    ErrorMessage === 'FLIGHT_FAILED' && RedirectUrlOnExpiration;

                // stopPerformanceCart(ErrorMessage);
                handleCustomError(`GetCart ${ErrorMessage}`);

                if (redirectFlightFailed) {
                    redirectTo(RedirectUrlOnExpiration, RedirectionType.Replace);
                } else {
                    store.dispatch('cart/setCartError', ErrorMessage);
                }
            } else {
                // Leave this, we need to investigate why we do this
                // There is a scenario when going back and forth in the session with corrupt products?!
                // add addons with 0 amount (included) to Products
                const affiliate = store.getters['cart/getAffiliate'];

                if (!affiliate) {
                    response.Products = response.Products.filter(
                        (product) => product.Type !== 'Addon'
                    );
                }

                loadFindOptimalItinerary();

                const cart = await mapInitialCartValues(response);

                store.dispatch('cart/setCartSuccess', cart);
                // stopPerformanceCart();
            }
        } else {
            throw new Error('Empty response');
        }
    } catch (error) {
        // stopPerformanceCart(error);
        handleCustomError(`GetCart ${error}`);
        store.dispatch('cart/setCartError');
    }
}

function loadFindOptimalItinerary() {
    // startPerformanceItinerary();

    endpoints.itinerary
        .FindOptimalItinerary()
        // .then(() => stopPerformanceItinerary())
        .catch((error: any) => {
            // stopPerformanceItinerary(error);
            handleCustomError(`FindOptimalItinerary ${error}`);
        });
}
